import React from "react";
import styled from "styled-components";
import { HeartStyle } from "../data/data";
import { HeartFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
const Container = styled.div`
  background: #fff;
  height: auto;
  padding: 5%;
  .content-con {
    text-align: center;
  }
  .rsvp {
    padding: 10px 50px;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto;
    margin-top: 20px;
    color: #606060;
    background-color: #fff;
    font-family: "Oswald", sans-serif;
    border: solid 1px #6a6a;
  }

  .rsvp:hover {
    background-color: #f0394d;
    border-color: #f0394d;
    color: #fff;
    visibility: visible;
  }
  .title {
    font-family: "Oswald", sans-serif;
    color: #333333;
    margin: 20px 0;
    font-size: 40px;
    @media (max-width: 767px) {
      font-size: 170%;
    }
  }
  #desc {
    font-family: muli;
    color: #123333;
    font-size: 15px;
  }
`;
export default function Rsvp() {
  return (
    <>
      <Container>
        <div className="content-con">
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 18, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{ fontSize: 19, marginLeft: -5, color: "#f2f2f2" }}
            />
            <span className="white-line"></span>
          </HeartStyle>
          <div>
            <h2 className="title">ARE YOU ATTENDING?</h2>
            <p id="desc">
              Please reserve before November 19th, 2021. Lorem ipsum dolor sit
              amet, consectetur adipiscing
            </p>
            <Link to="/rsvp-page">
              <span className="rsvp">RSVP</span>
            </Link>
          </div>
        </div>
      </Container>
    </>
  );
}
